import { render, staticRenderFns } from "./ExclamationTriangle.vue?vue&type=template&id=178c3635"
import script from "./ExclamationTriangle.vue?vue&type=script&lang=js"
export * from "./ExclamationTriangle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports